<div class="w-full h-full bg-[#103B33] flex flex-col items-center justify-center px-9 py-10 relative text-center text-white font-inter overflow-y-auto thin-scroll">

  <button
    matDialogClose
    type="button"
    class="absolute top-[20px] right-[20px] w-[32px] z-[2] h-[32px] rounded-full bg-white/[0.12] border-none cursor-pointer flex items-center justify-center text-[11px] font-semibold transition-colors hover:bg-white/20"
  >
    <mat-icon svgIcon="close" class="!w-full !h-auto max-w-[10px] max-h-[10px] text-white"></mat-icon>
  </button>

  <div class="flex flex-col items-center gap-4 w-full max-w-[448px] mx-auto">
    <div class="w-[72px] h-[72px] bg-white/10 rounded-full flex items-center justify-center">
      <mat-icon svgIcon="circle-usdt" class="!w-full !h-auto max-w-[56px] max-h-[56px]"></mat-icon>
    </div>

    <div class="flex flex-col items-center gap-2 w-full mt-1">
      <span class="text-[11px] font-bold tracking-[0.08em] text-[#A7F3D0] uppercase">
        Welcome Bonus
      </span>
      <h2 class="!m-0 !text-[64px] !font-bold leading-none tracking-tight">
        {{ data.rewardAmount | cutNumber:('1.2-2') }} USDT
      </h2>
    </div>

    <p class="!m-0 text-sm font-normal leading-[150%] text-[#C7EBDB] w-full px-2">
      Personalize your AML setup with a few quick questions — credited instantly to your balance.
    </p>

    <button [mat-dialog-close]="true" class="w-full bg-white text-[#103B33] font-semibold text-base py-3.5 px-6 rounded-[10px] hover:bg-emerald-50 active:scale-[0.99] transition-all mt-2">
      Start — get {{ data.rewardAmount | cutNumber:('1.2-2') }} USDT
    </button>

    <button matDialogClose class="w-full text-xs font-medium text-white/65 hover:text-white transition-colors pt-1">
      Maybe later
    </button>
  </div>
</div>
